import React from 'react'

import './index.scss'

export const CheckIcon: React.FC = () => (
  <svg className="icon icon--check" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M15.3333 6.00001L8.00001 13.3333L4.66667 10"
      strokeLinecap="square"
    />
  </svg>
)
